import { INITIAL_STATE } from './initial-state';
import { REDUCERS } from './reducers';

export const insurance = (state = INITIAL_STATE, { payload, type }) => {
  const reducer = REDUCERS[type];

  if (typeof reducer === 'undefined') {
    return state;
  }

  return reducer(state, payload);
};

export default insurance;
